import { render, staticRenderFns } from "./DashboardManufacture.vue?vue&type=template&id=6487b97a&scoped=true"
import script from "./DashboardManufacture.vue?vue&type=script&lang=js"
export * from "./DashboardManufacture.vue?vue&type=script&lang=js"
import style0 from "./DashboardManufacture.vue?vue&type=style&index=0&id=6487b97a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6487b97a",
  null
  
)

export default component.exports